export { default as Home } from './home';

// Sections
export { default as MagazineSection } from './magazine-section';
export { default as VideoSection } from './video-section';
export { default as PromoSingleSection } from './promo-single-section';
export { default as PromoBlockSection } from './promo-block-section';
export { default as QuoteBlockSection } from './quote-block-section';
export { default as IconBlockSection } from './icon-block-section';
export { default as BenefitCtaBlockSection } from './benefit-cta-block-section';
export { default as MultiColumnSection } from './multi-column-section';
